define.alias("shared/helpers/css-safe", "auth/helpers/css-safe");